import React from "react";

export const diarioDeUnGorrionPublishedAt = (
  <span className="white">
    <i>Otra vez en Lilac</i> (1942), <i>Cambam Bali</i> (1973) y <i>Retorno a Lilac</i> (1987)
  </span>
);
